import React from "react";
import { useAppSelector } from "../../hooks";
import { checkTimestampStatus, getByPath, getConfigByPath, validity } from "../../features/Sensors/SensorUtils";
type fields = {
    name: string;
    tension: string;
    speed: string;
    payout: string;
};

type DataBlockProps = {
    DataFields: fields[];
}

function WinchData({ DataFields }: DataBlockProps) {
    const measurements = useAppSelector(state => state.Measurements.measurements);
    const config = useAppSelector(state => state.Config.shipsconfig);
    return (
        <div className="w-full overflow-x-auto text-right">
            <table className="w-full table-auto">
                <thead>
                    <tr className='even:bg-white odd:dark:bg-gray-900 odd:bg-gray-200 odd:dark:bg-gray-800 border-b dark:border-gray-700 whitespace-nowrap'>
                        <th className="px-4 py-2">Name</th>
                        <th className="px-4 py-2">Tension (kg)</th>
                        <th className="px-4 py-2">Speed (meter / minute)</th>
                        <th className="px-4 py-2">Payout (m)</th>
                    </tr>
                </thead>
                <tbody>
                    {DataFields.map((field, index) => {
                        if(config){
                        const validity:validity = checkTimestampStatus(getByPath(field.tension,measurements)?.timestamp,getConfigByPath(field.tension, config)?.frequency);
                        return(
                            <tr className='odd:bg-white odd:dark:bg-gray-900 even:bg-gray-200 even:dark:bg-gray-800 border-b dark:border-gray-700 whitespace-nowrap' key={index}>
                                <td className={"border px-3 py-2 "+validity.color}>{field.name}</td>
                                <td className={"border px-3 py-2 "+validity.color}><div>{getByPath(field.tension,measurements)?.value}</div><div>{validity.icon}</div></td>
                                <td className={"border px-3 py-2 "+validity.color}><div>{getByPath(field.speed,measurements)?.value}</div><div>{validity.icon}</div></td>
                                <td className={"border px-3 py-2 "+validity.color}><div>{getByPath(field.payout,measurements)?.value}</div><div>{validity.icon}</div></td>
                            </tr>
                        )
                        }
                    })}
                </tbody>
            </table>
        </div>

    )
}

export default WinchData;